$(document).ready(function() {  


  $(document).on("click",".filters__tag__item .filters__tag_link",function(event) {
    event.preventDefault(); 
    if ($(document).find('.dropdown__tag_list').is(':visible')) {
       $(document).find('.filters__tag_link').removeClass('is-active');
       $(document).find(".dropdown__tag_list").slideUp("400");
     } 
    if ($(this).parents('.filters__tag__item').find(".dropdown__tag_list").is(':visible')){
      $(this).removeClass('is-active'); 
      $(this).parents('.filters__tag__item').find(".dropdown__tag_list").slideUp('400');
    } else {
       $(this).addClass('is-active'); 
       $(this).parents('.filters__tag__item').find(".dropdown__tag_list").slideDown('400');
    } 
 
 
});
$(document).mouseup(function(e) {
  var container = $('.dropdown__tag_list');
  if (!container.is(e.target) && container.has(e.target).length === 0){ 
      $(".dropdown__tag_list").slideUp('400');
      $(".filters__tag__item .filters__tag_link").removeClass('is-active'); 
  }
});

   
// ---------search-filter-start------------//
   
    $.expr[":"].CIcontains = $.expr.createPseudo(function (arg) {
  return function (elem) {
    return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
  };
});
  
 $(document).on("keyup",".waveColl__search .search__input.field__input",function() {  
    // var curr_text = $(this).val();  
    // $(".wave-collection--list .product-mix").hide();  
    // $(".wave-collection--list .product-mix:CIcontains('" + curr_text + "')").show(); 
    var value = $(this).val().toLowerCase(); 
    $(document).find('.wave-collection--list .product-mix').filter(function() { 
    // $(this).toggle($(this).find('.card__heading').text().toLowerCase().indexOf(value) > -1);
    $(this).toggle($(this).find('.card_music-type').text().toLowerCase().indexOf(value) > -1 || $(this).find('.card__heading').text().toLowerCase().indexOf(value) > -1);
  });
});
 

  
// ----------tag-filter-mobile------------//
$(document).on("click",".wave__filter_list .wave__filter_icon",function(event) {
  event.preventDefault();  
  // $('.wave__filter_list .filters__tag_list').toggleClass('is-active');  
  $('.wave__filter_list .filters__tag_list').slideToggle();  
});  
  
$(document).on("click",".waveColl__product_title span.product_icon-share",function(event) {
  event.preventDefault();  
  var var_id = $(this).attr('data-variant');
  $('.wave-collection--list .product-mix').each(function() { 
   // var allvar_id = $(this).find('form input.product-variant-id[name="id"]').val();
   var allvar_id = $(this).find('.quick-add input[name="id"]').val();
    if (allvar_id == var_id){ 
       $(this).find('.card-list_type .productIconShareurl').click(); 
    }
 });  
});
  $(document).on("click",".productIconShareurl",function(event) {
  event.preventDefault();  
    var full_url = $(this).attr('data-full');
    $(document).find('#shareListProduct-label').val(full_url);
  $(document).find('#shareListProduct_popup').show();
});  

  
$(document).on("click","span.shareListProductClose",function(event) {
  event.preventDefault();  
  $(document).find('#shareListProduct_popup').hide();
   $(document).find('button.shareListcopyButton').removeClass('is-done'); 
});
$(document).mouseup(function(e) {
  var container = $('#shareListProduct_popup');
  if (!container.is(e.target) && container.has(e.target).length === 0){ 
     $('#shareListProduct_popup').hide();  
  }
});
$(document).on("click","button.shareListcopyButton",function(event) { 
   event.preventDefault();  
  var selector = $(document).find('#shareListProduct-label'); 
  // selector.select();
  // selector.select();
  //  var $temp = $("<div>");
  // $("#shareListProduct_popup").append($temp);
  //   $temp.attr("contenteditable", true)
  //   .html($(selector).val()).select()
  //   .on("focus", function() { document.execCommand('selectAll',false,null); })
  //   .focus();
  //  document.execCommand('copy'); 
  //  $(this).addClass('is-done');  
  //  $temp.remove(); 
  
  var textToCopy = selector.val();  
    navigator.clipboard.writeText(textToCopy)
      .then(function() {
        console.log('Text copied to clipboard successfully'); 
      })
      .catch(function(err) {
        console.error('Unable to copy text to clipboard:', err); 
      });
   $(this).addClass('is-done');  
});


 $(document).on("click",".headerPlay_beats_btn .play_beats_btn",function(event) {
  event.preventDefault(); 
   var data_id = $(this).attr('href');
   if ($(document).find(data_id).attr('id') == 'WaveCollection-top') { 
   $('html, body').animate({
      scrollTop: $(data_id).offset().top,
    });
    }
   }); 
 
// -------bundle-add-cart-----------//

   $(document).on("click","#bundle-addToCartBtn",function(event) {
    event.preventDefault(); var submitButton = $(this)  
      submitButton.attr('aria-disabled', true);
      submitButton.addClass('loading');
      submitButton.find('.span').addClass('hidden');
      submitButton.find('.loading__spinner').removeClass('hidden');
     var formData = [], parent = $(this).closest('.bundle-inner');
     var randNumber = Math.floor(1e9+Math.random()*9e9);
      parent.find('product-form-list .extra-product-price').each(function() { 
      var variantId = $(this).find('form [name="id"]').val();
      var qty = $(this).find('form [name="quantity"]').val();
        formData.push({
        id: variantId,
        quantity: qty,
        properties: {
          'Bundle-Id': randNumber  
          }
        });
    });
      console.log(formData.entries,"outetr");
      console.log(formData,"ddd");
     if (formData.length > 0) {
       // console.log(formData.length); 
        var data = {
            items: formData
          }
        
      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      }).then((response) => {
        return response.json();
      }).then((cart) => {
        // window.location.href = "/cart"; 
        $("#cart-icon-bubble").load(location.href + ' #cart-icon-bubble > *', "");   
        $(".cart-drawer").load(location.href + ' .cart-drawer > *', ""); 
         setTimeout(() => { 
         $(".drawer").removeClass("is-empty"); 
         $(".drawer").addClass("active"); 
         }, 250);
        console.log('products',  cart);
        
        submitButton.removeAttr('aria-disabled');
        submitButton.removeClass('loading');
        submitButton.find('.span').removeClass('hidden');
        submitButton.find('.loading__spinner').addClass('hidden');
      }).catch((err) => { 
        console.error(err);
        
        submitButton.removeAttr('aria-disabled');
        submitButton.removeClass('loading');
        submitButton.find('span').removeClass('hidden');
        submitButton.find('.loading__spinner').addClass('hidden');
      });
        } else {
            console.log('No products selected.');
        }
  
   });

  
});


// ------- icon play pause -----------//

$(document).on("click", "#audio_visualCurrentTime.currTime", function() {
    const $parent = $(this).parents('.product_audio_visualization');
    const $iconContainer = $parent.find('.pause-play-icn');
    
    if ($(this).hasClass("is-active")) {
        $iconContainer.show();
        $iconContainer.find('.icon-play-2').show();
        $iconContainer.find('.icon--puase').hide();
    } else {
        $(this).css({ "position": "relative", "z-index": "2", "opacity": "0" });
        $iconContainer.show();
        $iconContainer.find('.icon--puase').show();
        $iconContainer.find('.icon-play-2').hide();
    }
});

 
document.addEventListener("DOMContentLoaded", (event) => {
  var checkcollection = document.querySelector('.wave__collection');
  if(checkcollection){
  var sectionId = document.querySelector('.wave__collection').getAttribute('data-id');
  if(sectionId){
  const collectionHandle = document.querySelector('.wave__collection').getAttribute('data-handle');
  document.addEventListener("change", function (event) {
    if (event.target.matches(".dropdown__tag__item input.dr__item--input") || event.target.closest("select.filters__sort_list")) {
     
      var allData = [];
      // console.log(event.target.value)
      let filterContainer = event.target.closest('.wave-collection__filter');
      if(screen.width < 750){
        filterContainer = event.target.closest('.mobile_filter')
      }
      filterContainer.querySelectorAll(".dropdown__tag__item").forEach(function (item) {
        var input = item.querySelector("input.dr__item--input");
        if (input && input.checked) {
          var dataValue = item.querySelector("input.dr__item--input:checked").value;
          var dataTag = item.querySelector("input.dr__item--input:checked")?.getAttribute("name");
          var combine = dataTag +'='+ dataValue;
          if (combine) {
            allData.push(combine);
          }
        }
      });
      var joinData = allData.join("&");
       $(".dropdown__tag_list").slideUp('400');
      $(".filters__tag__item .filters__tag_link").removeClass('is-active'); 
      let selectSort = filterContainer.querySelector("select.filters__sort_list").value;
      
    const serachValue = event.target.closest('.wave__collection').querySelector(".waveColl__search input").value;
    const collectionHandleurl = `/collections/${collectionHandle}`;
     
    if(serachValue){
      var url = `/search?q=${encodeURIComponent(serachValue)}&type=product&sort_by=${selectSort}&${joinData}&sections=${sectionId}`;
    }else{
      var url = `${collectionHandleurl}?sort_by=${selectSort}&${joinData}&sections=${sectionId}`;
      
    }
 
    filterCall(url,sectionId);
      
    }
    });
  }
  }

  if(document.querySelector('.shopify-section-header-sticky')){
    var headerHeight = document.querySelector('.shopify-section-group-header-group').offsetHeight;
    if(document.querySelector('.mobile_filter')){
      var featuredCollection = headerHeight + 6;
      document.querySelector('.mobile_filter').style.top = featuredCollection + 'px';
    }
    if(document.querySelector('.collection-template')){
      var featuredCollection = headerHeight + 6;
      // var searchHeight = document.querySelector('.mainColl__search').offsetHeight;
      // var mainCollection = featuredCollection + searchHeight + 6;
      // document.querySelector('.mainColl__search').style.top = featuredCollection + 'px';
      document.querySelector('aside.facets-wrapper').style.top = featuredCollection + 'px';
    }

    
  }
  
});

function filterCall(url,sectionId) {
  var productCollectionSection = document.querySelector('.main_loder');
  if(productCollectionSection){
  var collectionFilter = document.querySelector('.wave-collection__filter');
  var collectionMobileFilter = document.querySelector('.drawer_filter-remove');
  var removeFilter = document.querySelector('.removeall_filter');
  var collectionMobileFilterdrawer = document.querySelectorAll('.mobile-facets__list');
  console.log(url);
    productCollectionSection.classList.add('loading');
      fetch(url)
      .then(res => res.json())
      .then((content)=>{
        const parser = new DOMParser();
        let html = content[sectionId];
        const htmlconvert = parser.parseFromString(html, "text/html");
        var loadinghtml = htmlconvert.querySelector('.main_loder');
        var filterHtml = htmlconvert.querySelector('.wave-collection__filter');
        var filterHtmlMobile = htmlconvert.querySelector('.drawer_filter-remove');
        var filtertagdrawer = htmlconvert.querySelectorAll('.mobile-facets__list');
        var removefilterdrawer = htmlconvert.querySelector('.removeall_filter');
        if (loadinghtml && loadinghtml.innerHTML.trim().length) {
          productCollectionSection.innerHTML = loadinghtml.innerHTML;
          collectionFilter.innerHTML = filterHtml.innerHTML;
          collectionMobileFilter.innerHTML = filterHtmlMobile.innerHTML;
          collectionMobileFilterdrawer.forEach(function (item, index) {
            if (filtertagdrawer[index]) {
              item.innerHTML = filtertagdrawer[index].innerHTML;
            }
          });
          removeFilter.innerHTML = removefilterdrawer.innerHTML;
          productCollectionSection.classList.remove('loading');
           handleobserv();
        }
      })
  }
}
function debounce(func, delay) {
    let timeoutId;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(context, args), delay);
    };
}

$(document).on("input", ".waveColl__search .search__input.field__input", debounce(function () {
  var value = this.value.toLowerCase();
  let waveCollectionTop = document.querySelector("#WaveCollection-top");
  let sectionId = waveCollectionTop ? waveCollectionTop.getAttribute("data-id") : null;
  if (!sectionId) {
  const collectionHandle = document.querySelector('.wave__collection').getAttribute('data-handle');
    console.warn(" Section ID not found. Check #WaveCollection-top element.");
    return;
  }
  
  if(value == '' || null){
    const collectionHandleurl = `/collections/${collectionHandle}`;
    var url = `${collectionHandleurl}?&sections=${sectionId}`;
    filterCall(url, sectionId);
  } else {
    let url = `/search?q=${encodeURIComponent(value)}&type=product&sections=${sectionId}`;
    filterCall(url, sectionId);
    
    document.addEventListener("change", function (event) {
      if (event.target.matches(".dropdown__tag__item input.dr__item--input") || event.target.closest("select.filters__sort_list")) {
      
      var allData = [];
      let filterContainer = event.target.closest('.wave-collection__filter');
      if(screen.width < 750){
        filterContainer = event.target.closest('.mobile_filter')
      }
      filterContainer.querySelectorAll(".dropdown__tag__item").forEach(function (item) {
      var input = item.querySelector("input.dr__item--input");
        if (input && input.checked) {
          var dataValue = item.querySelector("input.dr__item--input:checked").value;
          var dataTag = item.querySelector("input.dr__item--input:checked")?.getAttribute("name");
          var combine = dataTag +'='+ dataValue;
          if (combine) {
            allData.push(combine);
          }
        }
      });
      var joinData = allData.join("&");
      $(".dropdown__tag_list").slideUp('400');
      $(".filters__tag__item .filters__tag_link").removeClass('is-active'); 
      const selectSort = event.target.closest('.wave__collection').querySelector("select.filters__sort_list").value;
     
      var url = `/search?q=${encodeURIComponent(value)}&type=product&${joinData}&sort_by=${selectSort}&sections=${sectionId}`;      
      filterCall(url,sectionId); 
      }
    });      
  }
}, 500));

document.addEventListener('click', function(event) {
    const filterButton = event.target.closest('.mobile_filter-collection');
    if (filterButton) {
        const filterContainer = filterButton.closest('.mobile_filter');
        if (filterContainer) {
            filterContainer.querySelectorAll('.mobile-collection__filter').forEach(element => {
                element.classList.add('open_filter');
            });
          document.querySelector('.wave-collection__inner').classList.add('show_filter');
        }
    }
    const closeButton = event.target.closest('.close_filter');
    if (closeButton) {
        const filterContainer = closeButton.closest('.mobile_filter');
        if (filterContainer) {
            filterContainer.querySelectorAll('.mobile-collection__filter').forEach(element => {
                element.classList.remove('open_filter');
            });
          document.querySelector('.wave-collection__inner').classList.remove('show_filter');
        }
    }
     if (event.target.closest(".wave__collection .active-facets__button-wrapper")) {
       event.preventDefault(); 
      const removeButton = event.target.closest(".wave__collection .active-facets__button-wrapper"); 
      var sectionId = removeButton.closest('.wave__collection').getAttribute('data-id');
      if(sectionId){
        const collectionHandle = document.querySelector('.wave__collection').getAttribute('data-handle');
        const collectionHandleurl = `/collections/${collectionHandle}`;
        var url = `${collectionHandleurl}?&sections=${sectionId}`
        
        filterCall(url,sectionId);
      }
    }
      if (event.target.closest(".removeall_filter .mobile-facets__clear-wrapper")) {
       event.preventDefault(); 
      const removeButton = event.target.closest(".removeall_filter .mobile-facets__clear-wrapper"); 
      var sectionId = removeButton.closest('.wave__collection').getAttribute('data-id');
      if(sectionId){
        const collectionHandle = document.querySelector('.wave__collection').getAttribute('data-handle');
        const collectionHandleurl = `/collections/${collectionHandle}`;
        var url = `${collectionHandleurl}?&sections=${sectionId}`
        
        filterCall(url,sectionId);
      }
    }
});

document.addEventListener("mouseup", function (e) {
  var container = document.querySelector(".mobile-facets__inner");
  
  if (container && !container.contains(e.target)) {
    document.querySelector(".mobile-collection__filter")?.classList.remove("open_filter");
    const waveCollection = document.querySelector('.wave-collection__inner');
    if(waveCollection){
      if (waveCollection.classList.contains('show_filter')) {
        waveCollection.classList.remove('show_filter');
      }
    }
  }
});


document.addEventListener("click", function(event) {
  if (event.target.closest('.wave__collection .active-facets .active-facets__button')) {
    event.preventDefault(); 

    const button = event.target.closest('.active-facets__button'); 
    const dataTitle = button.getAttribute('data-title'); 

    let filterContainer = button.closest('.wave-collection__filter');
    if (window.innerWidth < 750) { // More reliable way to check screen width
      filterContainer = button.closest('.mobile_filter');
    }

    if (filterContainer) {
      const checkboxes = filterContainer.querySelectorAll(`.dropdown__tag__item input[type="checkbox"][data-title="${dataTitle}"]:checked`);
      if (checkboxes.length > 0) {
        checkboxes.forEach(checkbox => {
          checkbox.click(); // Uncheck each matching checkbox
        });
      }
    }
  }

    if (event.target.closest(".mobile-facets__summary")) {
        document.querySelectorAll(".mobile-facets__details").forEach(function(element) {
            element.classList.remove("menu-opening");
        });

        event.target.closest(".mobile-facets__details").classList.add("menu-opening");
    }
    if (event.target.closest(".mobile-collection__filter .mobile-facets__close-button")) {
       const closeButton = event.target.closest(".mobile-collection__filter .mobile-facets__close-button");
        const parentDetails = closeButton.closest(".mobile-facets__details");
        if (parentDetails) {
            parentDetails.classList.remove("menu-opening");
        }
    }
    if (event.target.closest(".mobile-collection__filter .apply_drawer")) {
       const closeButton = event.target.closest(".mobile-collection__filter .apply_drawer");
    
        const parentDetails = closeButton.closest(".mobile-collection__filter");
        if (parentDetails) {
            parentDetails.classList.remove("open_filter");
        }
    }
    if (event.target.closest(".mobile-facets__inner .mobile-facets__clear")) {
      event.preventDefault();
      const closeButton = event.target.closest(".mobile-facets__inner .mobile-facets__clear");
      const parentDetails = closeButton.closest(".mobile-facets__submenu ");
      
      if (parentDetails) {
      const inputs = parentDetails.querySelectorAll('.dropdown__tag__item input[type="checkbox"]:checked');
        inputs.forEach(input => {
             input.click();
        });
      }
    }
  //   if (event.target.closest(".removeall_filter .mobile-facets__clear")) {
  //   event.preventDefault();
    
  //   // Select all checked checkboxes inside .dropdown__tag__item
  //   const checkedInputs = document.querySelectorAll('.dropdown__tag__item input[type="checkbox"]:checked');

  //   if (checkedInputs.length > 0) {
  //     checkedInputs.forEach(input => {
  //       input.click(); // Uncheck the checkbox
  //     });
  //   }
  // }
});

